<template>
  <el-drawer
    :title="title"
    :visible.sync="visible"
    size="50%"
    :before-close="cancel"
    direction="rtl"
  >
    <div class="drawer-container">
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        label-position="left"
        :rules="rules"
      >
        <div>
          <div class="leftTag">基本信息</div>
        </div>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="头像" prop="ProjectImg">
              <el-upload
                class="avatar-uploader"
                :action="
                  $rootUrl +
                  `/Base_Manage/Upload/ProjectOssUploadFileByForm?UserId=${userInfo.Id}&Type=4`
                "
                :headers="{
                  Authorization: token,
                }"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <el-image
                  v-if="form.Icon"
                  fit="contain"
                  class="projectImg"
                  :src="form.Icon"
                ></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物业单位编号" prop="PMC_Code">
              <el-input
                v-model="form.PMC_Code"
                placeholder="自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物业单位名称" prop="PMC_Name">
              <el-input v-model="form.PMC_Name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="PMC_Person">
              <el-input v-model="form.PMC_Person"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="PMC_Phone">
              <el-input v-model="form.PMC_Phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="form.Remarks"
                type="textarea"
                :autosize="{ minRows: 4 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="drawer-footer">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button size="mini" @click="confirm" type="primary">保存</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { mapState } from 'vuex'
import Token from '@/utils/cache/TokenCache.js'
import validate from '@/utils/validate/validate.js'
export default {
  data() {
    return {
      token: 'Bearer ' + Token.getToken(),
      visible: false,
      rules: {
        PMC_Name: [{ required: true, message: '请输入物业单位名称' }],
        PMC_Person: [{ required: true, message: '请输入联系人' }],
        PMC_Phone: [
          {
            validator: validate.validatePhone,
            trigger: 'blur',
            required: true,
            message: '请输入正确的手机号',
          },
        ],
      },
      ecList: [],
      form: {},
      title: '',
      defaultKeys: [0], // 指定哪些节点的子节点默认展开
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      checkedNodes: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file)
      if (res.code == 200) {
        this.$set(this.form, 'Icon', res.url)
        // this.form.Icon = res.url;
      } else {
        this.$notify.error(res.Msg)
      }
    },
    open(form, title) {
      this.title = title
      this.visible = true
      this.form = JSON.parse(JSON.stringify(form))
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .post('/Base_BasicData/Base_PMC/SaveData', this.form)
            .then((res) => {
              if (res.Success) {
                this.$notify.success('操作成功')
                this.$emit('comfirm', true)
                this.visible = false
              } else {
                this.$notify.error(res.Msg)
              }
            })
        } else {
          return false
        }
      })
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    getCheckedNodes() {
      const nodes = this.$refs.tree.getCheckedNodes() // 获取所有选中的节点数据
      this.checkedNodes = nodes.map((node) => node.id) // 只获取节点的 ID 并存储在 checkedNodes 中
    },
    cancel() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 100)
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 0 20px;
}

.drawer-container {
  padding: 20px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 60px;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
}

.leftTag {
  margin: 20px 0;
  // margin-left: -20px;
  width: 98px;
  padding: 10px;
  padding-right: 30px;
  background: #409eff;
  border-radius: 0 100px 100px 0;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}
::v-deep .avatar-uploader .el-upload {
  width: 150px;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
